import { getXAxisTitleText, getChartDateFormat, getTickPositions, getChartDateFormatForTooltip, formattedValue, } from '@/containers/report/chartFunctions';
export function getApplianceChartOptions(tabname, locale, data, t) {
    return {
        chart: {
            type: 'column',
            height: 480,
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            borderRadius: 0,
            itemMarginTop: 1,
            squareSymbol: true,
            symbolWidth: 4,
            symbolPadding: 10,
            verticalAlign: 'top',
            y: 10,
            symbolRadius: 0,
            itemStyle: {
                fontWeight: 'regular',
            },
        },
        yAxis: [
            {
                offset: 20,
                labels: {
                    style: {
                        color: '#434348',
                    },
                    formatter() {
                        return `${this.value}k`;
                    },
                },
                title: {
                    text: `${t('device.energy')}(Wh)`,
                    margin: 10,
                    style: {
                        color: '#434348',
                    },
                },
                opposite: true,
                min: 0,
                tickAmount: 6,
            },
        ],
        xAxis: [
            {
                title: {
                    text: getXAxisTitleText(tabname, t),
                    align: 'high',
                },
                labels: {
                    autoRotation: [0],
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
                tickPositions: getTickPositions(tabname, data.smartPlugData?.map((item) => item.x)),
            },
        ],
        tooltip: {
            shared: true,
            formatter() {
                return getValueOfToolTip(tabname, this, locale, t);
            },
            useHTML: true,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                grouping: true,
            },
        },
        series: [
            {
                type: 'column',
                name: 'Heat Pump',
                color: '#c998ff',
                data: data.heatPumpData,
            },
            {
                type: 'column',
                name: 'Air Conditioner',
                color: '#a987fa',
                data: data.airConditionerData,
            },
            {
                type: 'column',
                name: 'Smart Plug',
                color: '#c998ffcc',
                data: data.smartPlugData,
            },
            {
                type: 'column',
                name: 'TV',
                color: '#aa4ed8cc',
                data: data.tvData,
            },
        ],
        scrollbar: {
            enabled: true,
        },
        navigator: {
            xAxis: {
                labels: {
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
            },
        },
        noData: {
            position: {},
            attr: {},
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#202030',
            },
        },
    };
}
export function getChartByApplianceOptions(tabname, locale, data, name, t) {
    return {
        chart: {
            type: 'column',
            height: 400,
            width: 520,
            zoomType: 'x',
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            borderRadius: 0,
            itemMarginTop: 1,
            squareSymbol: true,
            symbolWidth: 4,
            symbolPadding: 10,
            verticalAlign: 'top',
            y: 10,
            symbolRadius: 0,
            itemStyle: {
                fontWeight: 'regular',
            },
        },
        yAxis: [
            {
                offset: 20,
                labels: {
                    style: {
                        color: '#434348',
                    },
                    formatter() {
                        return `${this.value}k`;
                    },
                },
                title: {
                    text: `${t('device.energy')}(Wh)`,
                    margin: 10,
                    style: {
                        color: '#434348',
                    },
                },
                opposite: true,
                min: 0,
                tickAmount: 6,
            },
        ],
        xAxis: [
            {
                title: {
                    text: getXAxisTitleText(tabname, t),
                    align: 'high',
                },
                labels: {
                    autoRotation: [0],
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
                tickPositions: getTickPositions(tabname, data?.map((item) => item.x)),
            },
        ],
        tooltip: {
            shared: true,
            formatter() {
                return getValueOfToolTip(tabname, this, locale, t, 2);
            },
            useHTML: true,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                grouping: true,
            },
        },
        series: [
            {
                type: 'column',
                name,
                color: '#a9e6e4',
                data,
            },
        ],
        scrollbar: {
            enabled: true,
        },
        navigator: {
            xAxis: {
                labels: {
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
            },
        },
        noData: {
            position: {},
            attr: {},
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#202030',
            },
        },
    };
}
export function getValueOfToolTip(tabname, object, locale, t, decimal = 2) {
    const container = document.createElement('span');
    container.setAttribute('style', `
          position: absolute;
          font-family: 'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif;
          font-size: 12px;
          white-space: nowrap;
          margin-left: 0px;
          margin-top: 0px;
          left: 8px;
          top: 8px;
          color: rgb(51, 51, 51);
          `);
    const date = document.createElement('span');
    date.innerHTML = `${getChartDateFormatForTooltip(tabname, object.x)} <br/>`;
    const table = document.createElement('table');
    const tbody = table.createTBody();
    object.points?.forEach((item) => {
        const tr = document.createElement('tr');
        const td = document.createElement('td');
        const specialCharacters = document.createElement('span');
        const energyName = document.createElement('span');
        const energyValue = document.createElement('span');
        specialCharacters.setAttribute('style', `color: ${item.color}; padding: 0`);
        specialCharacters.innerHTML = '● ';
        energyName.innerHTML = `<b>${item.series.name}</b> : <br/>`;
        energyValue.setAttribute('style', 'padding : 0');
        energyValue.innerHTML = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - ${getEnergyValue(item, locale, t, decimal)} <br/>`;
        td.append(specialCharacters);
        td.append(energyName);
        td.append(energyValue);
        tr.append(td);
        tbody.append(tr);
    });
    table.append(date);
    table.append(tbody);
    container.append(table);
    return `${container.innerHTML}`;
}
function getEnergyValue(item, locale, t, decimal = 2) {
    return `${t('common.energy')} : ${item != null ? formattedValue(item.y, locale, decimal) : 0}KWh`;
}
